/**
 * DevExtreme (esm/__internal/pagination/common/pagination_config_context.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { createContext } from "../../core/r1/runtime/inferno/index";
export const PaginationConfigContext = createContext(void 0);